// @file: src/index.js
// Importa bootstrap CSS localmente para evitar dependência de CDN/HTTPS em TVs antigas
import "bootstrap/dist/css/bootstrap.min.css";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
